import styled, { css } from 'styled-components';

import { BUTTON_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

import { NEUTRAL_COLORS, SEMANTIC_COLORS } from '../styles/colors';
import { TYPOGRAPHY } from '../Typography';

import type { ButtonVariant } from './Button.types';

const getVariantStyles = (variant: ButtonVariant) => {
  switch (variant) {
    case 'primary':
      return css`
        background-color: ${NEUTRAL_COLORS['charcoal-500']};
        color: ${NEUTRAL_COLORS['white-50']};

        &:hover:not(:disabled) {
          background-color: ${NEUTRAL_COLORS['charcoal-900']};
        }

        &:active:not(:disabled) {
          background-color: ${NEUTRAL_COLORS['charcoal-900']};
        }

        &:disabled {
          background-color: ${NEUTRAL_COLORS['charcoal-50']};
          color: ${NEUTRAL_COLORS['charcoal-200']};
        }
      `;

    case 'secondary':
      return css`
        background-color: ${NEUTRAL_COLORS['white-300']};
        color: ${NEUTRAL_COLORS['charcoal-500']};

        &:hover:not(:disabled) {
          background-color: ${NEUTRAL_COLORS['white-500']};
        }

        &:active:not(:disabled) {
          background-color: ${NEUTRAL_COLORS['white-500']};
        }

        &:disabled {
          background-color: ${NEUTRAL_COLORS['charcoal-50']};
          color: ${NEUTRAL_COLORS['charcoal-200']};
        }
      `;

    case 'tertiary':
      return css`
        background-color: transparent;
        color: ${NEUTRAL_COLORS['charcoal-500']};

        &:hover:not(:disabled) {
          background-color: ${NEUTRAL_COLORS['charcoal-alpha-50']};
        }

        &:active:not(:disabled) {
          background-color: ${NEUTRAL_COLORS['charcoal-alpha-50']};
        }

        &:disabled {
          color: ${NEUTRAL_COLORS['charcoal-200']};
        }
      `;
  }
};

export const S = {
  Button: styled.button<{
    variant: ButtonVariant;
    $fullWidth?: boolean;
  }>`
    ${BUTTON_RESET}
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${SPACING.size8};
    padding: ${SPACING.size12} ${SPACING.size16};
    border-radius: 10px;
    border: none;
    transition: all 0.2s ease;
    width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

    &:focus-visible {
      outline: 2px solid ${SEMANTIC_COLORS['info-500']};
      outline-offset: 4px;
    }

    &:disabled {
      cursor: not-allowed;
    }

    ${({ variant }) => getVariantStyles(variant)}
  `,

  Label: styled.span`
    ${TYPOGRAPHY.labelMediumMediumDense}
    display: flex;
    align-items: center;
    justify-content: center;
  `
};
